import React, { useState } from 'react'
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  IconButton,
  Typography,
  Avatar,
  CardHeader,
  ButtonBase,
  Divider,
  Grid,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import ShareIcon from '@material-ui/icons/Share'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { deletePost } from '../../../actions/posts'
import PopupForm from '../../Form/PopupForm'
import useStyles from './styles'
import EnterDialog from '../../EnterDialog/EnterDialog'
import ShareDialog from '../../ShareDialog/ShareDialog'

const Room = ({ post, currentId, setCurrentId }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const now = moment().format('LLLL')
  const start = moment(post.roomStart).format('LLLL')
  const userNow = JSON.parse(localStorage.getItem('profile'))
  const { user } = useSelector((state) => state.user)
  const [open, setOpen] = useState(false)
  const [enter, setEnter] = useState(false)
  const [openShare, setOpenShare] = useState(false)

  const handleClickOpen = (e) => {
    setCurrentId(post._id)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const handleClickEnter = () => {
    setEnter(true)
  }

  const handleCloseEnter = () => {
    setEnter(false)
  }
  const handleClickShare = () => {
    setOpenShare(true)
  }

  const handleCloseShare = () => {
    setOpenShare(false)
  }

  const login = () => {
    dispatch({ type: 'AUTH' })

    history.push('/login')
  }

  const roomDetails = () => {
    history.push(`/posts/${post._id}`)
  }
  const userPage = () => {
    history.push(`/user/${post.username}`)
  }

  return (
    <Card className={classes.card} raised elevation={3}>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Avatar
            onClick={userPage}
            alt={post.username}
            src={user?._id === post.creator ? user?.avatar : post.avatar}
          >
            {post.username.charAt(0)}
          </Avatar>
        }
        title={
          <Typography onClick={userPage}>
            {user?._id === post.creator ? user?.username : post.username}
          </Typography>
        }
        subheader={moment(post.createAt).fromNow()}
        action={
          (userNow?.result?.googleId === post?.creator ||
            userNow?.result?._id === post.creator) && (
            <IconButton
              className={classes.moreButton}
              size='small'
              onClick={handleClickOpen}
            >
              <MoreVertIcon fontSize='medium' />
            </IconButton>
          )
        }
      />
      <PopupForm
        open={open}
        handleClose={handleClose}
        currentId={currentId}
        setCurrentId={setCurrentId}
      />
      <ButtonBase
        component='span'
        name='test'
        className={classes.cardAction}
        onClick={roomDetails}
      >
        <CardMedia
          className={classes.media}
          image={post.selectedFile}
          title={post.title}
        />
        <CardContent>
          <Grid className={classes.categorynStatus}>
            <Typography variant='h5' className={classes.category}>
              {post.category}
            </Typography>
            {now < start ? (
              <Typography variant='body2' className={classes.progressTime}>
                Start {moment(post.roomStart).fromNow()}
              </Typography>
            ) : (
              now >= start && (
                <Typography variant='body2' className={classes.progressTime}>
                  End {moment(post.roomEnd).fromNow()}
                </Typography>
              )
            )}
          </Grid>

          <Typography className={classes.title} variant='h5' gutterBottom>
            {post.title.substring(0, 31) + (post.title.substring(31) && ' ...')}
          </Typography>

          <Grid className={classes.roomTime}>
            <Typography variant='h6' className={classes.timeTitle}>
              Start:
              <Typography className={classes.dateRoom}>
                {moment(post.roomStart).format('ll')}
              </Typography>
              <Typography className={classes.timeRoom}>
                {moment(post.roomStart).format('LT')}
              </Typography>
            </Typography>
            <Divider
              orientation='vertical'
              flexItem
              style={{ margin: '5px 0' }}
            />
            <Typography variant='h6' className={classes.timeTitle}>
              End:
              <Typography className={classes.dateRoom}>
                {moment(post.roomEnd).format('ll')}
              </Typography>
              <Typography className={classes.timeRoom}>
                {moment(post.roomEnd).format('LT')}
              </Typography>
            </Typography>
          </Grid>
        </CardContent>
      </ButtonBase>
      <CardActions className={classes.cardActions}>
        <Button
          variant='contained'
          className={classes.button}
          onClick={userNow?.result ? handleClickEnter : login}
        >
          🚪 Enter
        </Button>
        <EnterDialog
          post={post}
          enter={enter}
          roomCategory={post.category}
          handleCloseEnter={handleCloseEnter}
        />
        <IconButton
          aria-label='share'
          className={classes.buttonSmall}
          onClick={handleClickShare}
        >
          <ShareIcon fontSize='small' />
        </IconButton>
        <ShareDialog
          post={post}
          openShare={openShare}
          handleCloseShare={handleCloseShare}
        />

        {(userNow?.result?.googleId === post?.creator ||
          userNow?.result?._id === post.creator) && (
          <IconButton
            aria-label='delete'
            className={classes.buttonSmall}
            onClick={() => dispatch(deletePost(post._id))}
          >
            <DeleteIcon fontSize='small' />
          </IconButton>
        )}
      </CardActions>
    </Card>
  )
}

export default Room
